import { i18n } from 'i18next'
import { Count } from './membershipCaclulatorState'

// export const organizationConcerns = new Map<string, Concern>([
//   ['concern_1', { label: 'Vervoer', value: 'vervoer' }],
//   [
//     'concern_2',
//     { label: 'Internationaal ondernemen', value: 'internationaal ondernemen' }
//   ],
//   [
//     'concern_3',
//     { label: 'Supply chain management', value: 'supply chain management' }
//   ],
//   ['concern_4', { label: 'Magazijnen', value: 'magazijnen' }],
//   ['concern_5', { label: 'Gevaarlijke stoffen', value: 'gevaarlijke stoffen' }]
// ])

export const employeeCount = new Map<string, Count>([
  ['count_1', { label: '0-19', value: 10, cost: 538 }],
  ['count_2', { label: '20-99', value: 60, cost: 1158 }],
  ['count_3', { label: '100-199', value: 150, cost: 2243 }],
  ['count_4', { label: '200-499', value: 350, cost: 4647 }],
  ['count_5', { label: '500+', value: 500, cost: 7720 }]
])

export const calculatorText = (translator: i18n) => ({
  title: translator.t('membership:title'),
  description: translator.t('membership:description'),
  employeeCountQuestion: translator.t('membership:employeeCountQuestion'),
  resultOfferTitle: translator.t('membership:resultOfferTitle'),
  internalActionLink: INTERNAL_ACTION_LINK,
  internalActionLabel: "of kijk of je in aanmerking komt voor het actietarief.",
  resultOfferPerks: {
    count_1: [
      translator.t('membership:resultOfferPerks1x1'),
      translator.t('membership:resultOfferPerks1x2'),
      translator.t('membership:resultOfferPerks1x3'),
      translator.t('membership:resultOfferPerks1x4'),
      translator.t('membership:resultOfferPerks1x5'),
      translator.t('membership:resultOfferPerks1x6')
    ],
    count_2: [
      translator.t('membership:resultOfferPerks2x1'),
      translator.t('membership:resultOfferPerks2x2'),
      translator.t('membership:resultOfferPerks2x3'),
      translator.t('membership:resultOfferPerks2x4'),
      translator.t('membership:resultOfferPerks2x5'),
      translator.t('membership:resultOfferPerks2x6')
    ],
    count_3: [
      translator.t('membership:resultOfferPerks3x1'),
      translator.t('membership:resultOfferPerks3x2'),
      translator.t('membership:resultOfferPerks3x3'),
      translator.t('membership:resultOfferPerks3x4'),
      translator.t('membership:resultOfferPerks3x5'),
      translator.t('membership:resultOfferPerks3x6')
    ],
    count_4: [
      translator.t('membership:resultOfferPerks4x1'),
      translator.t('membership:resultOfferPerks4x2'),
      translator.t('membership:resultOfferPerks4x3'),
      translator.t('membership:resultOfferPerks4x4'),
      translator.t('membership:resultOfferPerks4x5'),
      translator.t('membership:resultOfferPerks4x6')
    ],
    count_5: [
      translator.t('membership:resultOfferPerks5x1'),
      translator.t('membership:resultOfferPerks5x2'),
      translator.t('membership:resultOfferPerks5x3'),
      translator.t('membership:resultOfferPerks5x4'),
      translator.t('membership:resultOfferPerks5x5'),
      translator.t('membership:resultOfferPerks5x6')
    ]
  },
  contactPhoneNr: translator.t('membership:phoneNr'),
  contactPhoneText: translator.t('membership:phoneNrLabel')
})

export const INTERNAL_ACTION_LINK = "https://eur02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.evofenedex.nl%2Flidmaatschap%2Flidmaatschapsprijzen&data=05%7C02%7C%7C7911fca2d4c343c48bf108ddf5270ff3%7C24ba8c8958b848b6a59d94cc0f13af5f%7C0%7C0%7C638936270309232379%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=9%2FQIBN02k89ZNx0AXMPddqcBglnGj5hUipczpbQ8IRg%3D&reserved=0"
